var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-nowrap show-entries mb-1 mb-md-0"},[_c('span',{attrs:{"sm":""}},[_vm._v(" Show "),_vm._t("input"),_vm._v(" entries ")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }